/** Menschliche Distanz. Nie „vor -22503s“. */
export function relativeZeit(
  iso: string | null | undefined,
  jetzt = Date.now(),
): string {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return "";
  return abstandText(Math.round((jetzt - then) / 1000));
}

/**
 * Dieselbe Distanz aus einer fertigen Sekundenzahl. (28.09.2026, Ticket 2727)
 *
 * Der Tab-Kontext meldet sein Alter selbst (`alter_sekunden`, gemessen beim
 * Aufruf) — die Karte darf es nicht gegen JETZT rechnen, sonst hieße ein
 * neu geladener Verlauf „vor 3h“. Die Stufen bleiben an EINER Stelle.
 */
export function abstandText(seconds: number): string {
  if (seconds < 45) return "gerade eben";
  if (seconds < 3600) return `vor ${Math.round(seconds / 60)}min`;
  if (seconds < 86400) return `vor ${Math.round(seconds / 3600)}h`;
  return `vor ${Math.round(seconds / 86400)}d`;
}

/**
 * Dieselbe Distanz in ganzen Wörtern. (06.10.2026, Glocke)
 *
 * „vor 20 Stunden“ statt „vor 20h“, „gestern“, „vor 4 Tagen“ — für eine
 * Nebenzeile, die gelesen und nicht entziffert werden soll. Abgerundet: was
 * 59 Minuten alt ist, ist nicht „vor 60 Minuten“.
 */
export function relativeZeitInWorten(
  iso: string | null | undefined,
  jetzt = Date.now(),
): string {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return "";
  const s = Math.max(0, (jetzt - then) / 1000);
  if (s < 45) return "gerade eben";
  if (s < 3600) {
    const m = Math.max(1, Math.floor(s / 60));
    return m === 1 ? "vor einer Minute" : `vor ${m} Minuten`;
  }
  if (s < 86400) {
    const h = Math.floor(s / 3600);
    return h === 1 ? "vor einer Stunde" : `vor ${h} Stunden`;
  }
  const t = Math.floor(s / 86400);
  return t === 1 ? "gestern" : `vor ${t} Tagen`;
}

/**
 * Der genaue Zeitpunkt in Ortszeit: „heute, 14:32“, „gestern, 09:10“, sonst „04.10., 12:00“. (07.10.2026, Glocke)
 *
 * Für „Einzelheiten“ eines Bündels: dort sind die Sätze gleich, und „gestern / gestern“ sagt nicht, welcher Anruf
 * wann war. Gerechnet wird in Kalendertagen der Ortszeit (nicht in 24-Stunden-Schritten wie `relativeZeitInWorten`):
 * wer um 23:50 anrief, hat „gestern“ angerufen, sobald es Mitternacht war.
 */
export function uhrzeitInWorten(
  iso: string | null | undefined,
  jetzt = Date.now(),
): string {
  if (!iso) return "";
  const dann = new Date(iso);
  if (!Number.isFinite(dann.getTime())) return "";
  const zwei = (n: number): string => String(n).padStart(2, "0");
  const uhr = `${zwei(dann.getHours())}:${zwei(dann.getMinutes())}`;
  const tag = (d: Date): number => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const tage = Math.round((tag(new Date(jetzt)) - tag(dann)) / 86_400_000);
  if (tage === 0) return `heute, ${uhr}`;
  if (tage === 1) return `gestern, ${uhr}`;
  return `${zwei(dann.getDate())}.${zwei(dann.getMonth() + 1)}., ${uhr}`;
}
